import { useState } from 'react';
import { Eye } from 'lucide-react';
import { Button } from './ui/button';
import { useSession } from './session-context';
import { stopViewAs } from '../lib/view-as';

export default function ViewAsBanner() {
  const { viewAs } = useSession();
  const [leaving, setLeaving] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);
  if (!viewAs) return null;

  async function leave() {
    setLeaving(true);
    setProblem(null);
    try {
      await stopViewAs();
    } catch (err) {
      setProblem(err instanceof Error ? err.message : 'Could not go back to your view.');
      setLeaving(false);
    }
  }

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-950 md:px-6 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-100"
    >
      <Eye className="h-4 w-4 shrink-0" aria-hidden />
      <p className="min-w-0 flex-1">
        <span className="font-medium">You're viewing Pulse as {viewAs.name}.</span>{' '}
        You see what they see. Changes are turned off.
        {problem ? <span className="ml-2 text-red-700 dark:text-red-300">{problem}</span> : null}
      </p>
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="h-7 border-amber-400 bg-white/70 text-amber-950 hover:bg-white dark:border-amber-700 dark:bg-transparent dark:text-amber-100"
        disabled={leaving}
        onClick={() => void leave()}
      >
        {leaving ? 'Going back...' : 'Back to my view'}
      </Button>
    </div>
  );
}
